export const normalizeStoryblokSlug = (
	fullSlug: string | null | undefined
): string => {
	if (!fullSlug) {
		return "";
	}

	let cleanSlug = fullSlug.replace(/^\/+/, "");

	cleanSlug = cleanSlug.replace(/^([a-z]{2}(?:-[A-Za-z]{2})?)\//i, "");

	return cleanSlug;
};
